// import React, { useState, useContext } from "react";
// import Footer from "../../components/Footer/Footer";
// import Search from "../../components/Searchbar/Search";
// import SsoPage from "./SsoPage";
// import { FilterProvider } from "../../context/Filter";
// import { FilterContext } from "../../context/Filter";
// import Header from "../../components/Header/Header";
// import NavButtons from "../../components/NevBar/NavButtons";
// import WaterMark from "../../components/WaterMark";

// const SsoIndexPage = () => {
//   const [activeSSO, setActiveSSO] = useState("SSO Total Complaints");
//   const [totalSsoData, setSsoData] = useState(null);
//   // const [selectedSearchType, setSelectedSearchType] = useState("");
//   // const [searchData, setSearchData] = useState([]);
//   const { searchData, setSearchData, selectedSearchType, setSelectedSearchType } = useContext(FilterContext);

//   return (
//     <>
//       <WaterMark />
//       <Header />
//       <FilterProvider>
//         <Search
//           activeSSO={activeSSO}
//           setActiveSSO={setActiveSSO}
//           totalSsoData={totalSsoData}
//           setSsoData={setSsoData}
//           selectedSearchType={selectedSearchType}
//           setSelectedSearchType={setSelectedSearchType}
//           searchData={searchData}
//           setSearchData={setSearchData}
//         />
//         <SsoPage
//           activeSSO={activeSSO}
//           setActiveSSO={setActiveSSO}
//           totalSsoData={totalSsoData}
//           setSsoData={setSsoData}
//           selectedSearchType={selectedSearchType}
//           setSelectedSearchType={setSelectedSearchType}
//           searchData={searchData}
//           setSearchData={setSearchData}
//         />
//         <Footer />

//       </FilterProvider>
//       {/* <NavButtons /> */}
//     </>
//   );
// };
// export default SsoIndexPage;
import React, { useState, useContext } from "react";
import Footer from "../../components/Footer/Footer";
import Search from "../../components/Searchbar/Search";
import SsoPage from "./SsoPage";
import { FilterProvider } from "../../context/Filter";
import { FilterContext } from "../../context/Filter";
import Header from "../../components/Header/Header";
import NavButtons from "../../components/NevBar/NavButtons";
import WaterMark from "../../components/WaterMark";

const SsoIndexPage = () => {
  const [activeSSO, setActiveSSO] = useState("SSO Total Complaints");
  const [totalSsoData, setSsoData] = useState(null);
  const { searchData, setSearchData, selectedSearchType, setSelectedSearchType } = useContext(FilterContext);

  // Reset Handler
  const handleReset1 = () => {
    // console.log("Reset button clicked");
    setActiveSSO("SSO Total Complaints");
    setSsoData(null);
    setSearchData([]);
    setSelectedSearchType("");
  };

  return (
    <>
      <WaterMark />
      <Header />
      <FilterProvider>
        <Search
          activeSSO={activeSSO}
          setActiveSSO={setActiveSSO}
          totalSsoData={totalSsoData}
          setSsoData={setSsoData}
          selectedSearchType={selectedSearchType}
          setSelectedSearchType={setSelectedSearchType}
          searchData={searchData}
          setSearchData={setSearchData}
          handleReset1={handleReset1}
        />

        {/* Reset Button Section */}
        <div className="bg-gray-50  px-4 py-2  flex justify-end">
          <button
            onClick={handleReset1}
            className="px-4 py-2 bg-gray-200 lg:-translate-x-48  translate-y-1 md:-translate-y-12 hover:bg-gray-300 rounded-md text-gray-700 border border-gray-300 transition-colors duration-200 flex items-center gap-2 shadow-sm"
          >

            Reset
          </button>
        </div>

        <SsoPage
          activeSSO={activeSSO}
          setActiveSSO={setActiveSSO}
          totalSsoData={totalSsoData}
          setSsoData={setSsoData}
          selectedSearchType={selectedSearchType}
          setSelectedSearchType={setSelectedSearchType}
          searchData={searchData}
          setSearchData={setSearchData}
        />
        <Footer />
      </FilterProvider>
      {/* <NavButtons /> */}
    </>
  );
};

export default SsoIndexPage;